import './LandIndustryDrawer.css'
import 'antd/dist/reset.css'
import React from 'react'
import { ConfigProvider, Drawer, Menu } from 'antd'
import { industries } from '../../products/ProductProvider'

export const industryDrawerHeight = 400

export default class LandIndustryDrawer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {}

  render() {
    return (
      <Drawer
        height={industryDrawerHeight}
        title={null}
        placement="top"
        closeIcon={null}
        open={this.props.open}
        rootStyle={{ position: 'fixed', top: '10vh', zIndex: 100 }}
        styles={{
          header: {
            paddingLeft: '8vw',
            paddingRight: '8vw',
            paddingTop: '0px',
            paddingBottom: '0px',
          },
          body: {
            paddingLeft: '8vw',
            paddingRight: '8vw',
            paddingTop: '0px',
            paddingBottom: '0px',
          },
        }}
      >
        <ConfigProvider
          theme={{
            components: {
              Menu: {
                itemHeight: 50,
                itemMarginInline: 0,
              },
            },
          }}
        >
          <Menu
            items={this.getIndustryMenuItems()}
            selectable={false}
            style={{ marginTop: 10 }}
          />
        </ConfigProvider>
      </Drawer>
    )
  }

  getIndustryMenuItems = () => {
    const items = []
    for (var i = 0; i < industries.length; i++) {
      items.push(this.getIndustryMenuItem(industries[i]))
    }
    return items
  }

  getIndustryMenuItem = (industry) => {
    return {
      key: industries.iid,
      label: (
        <div
          className="LandIndustryName"
          onClick={() => {
            this.props.handleClose()
            this.viewIndustryInfo(industry.iid)
          }}
        >
          {industry.name}
        </div>
      ),
    }
  }

  viewIndustryInfo = (iid) => {
    this.props.history.push('/industry?iid=' + iid)
  }
}
